export const NAV_LINKS = [
  { label: "Home", to: "/", testId: "nav-link-home" },
  { label: "About Us", to: "/about", testId: "nav-link-about" },
  { label: "Our Services", to: "/services", testId: "nav-link-services" },
  { label: "Case Studies", to: "/case-studies", testId: "nav-link-case-studies" },
  { label: "Blog", to: "/blog", testId: "nav-link-blog" },
  { label: "Contact Us", to: "/contact", testId: "nav-link-contact" },
];

export const CONTACT = {
  email: "contact@marketrounds.com",
  phone: "+44 (0) 7563706774",
  address: "NBV Enterprise Centre, 6 David Lane, Old Basford, Nottingham, UK. NG6 0JU",
  socials: [
    { label: "LinkedIn", href: "https://www.linkedin.com/company/market-rounds-technologies/" },
    { label: "YouTube", href: "https://www.youtube.com/@MarketRoundsTechnologies" },
  ],
};

export const CLIENTS = [
  { name: "Afara Consulting", logo: "/assets/logos/afara.png" },
  { name: "Ciesto Solutions", logo: "/assets/logos/ciesto.png" },
  { name: "Decarboniq", logo: "/assets/logos/decarboniq.png" },
  { name: "MigTribe", logo: "/assets/logos/migtribe.png" },
  { name: "The Light Oil & Gas", logo: "/assets/logos/lightoil.png" },
  { name: "Souce Property", logo: "/assets/logos/souceproperty.png" },
  { name: "AI Warehouse", logo: "/assets/logos/aiwarehouse.svg" },
];

export const CASE_STUDIES = [
  {
    slug: "the-light-oil-and-gas",
    testId: "case-study-card-light-oil",
    client: "The Light Oil & Gas",
    url: "https://thelightoilandgas.com/",
    domain: "thelightoilandgas.com",
    category: "Energy & Industrial",
    image: "/assets/cases/lightoil.png",
    imageFull: "/assets/cases/lightoil_full.png",
    title: "Enterprise platform for a global oil & gas supplier",
    summary:
      "A commanding digital presence for a supplier empowering upstream, midstream and downstream sectors across Sub-Saharan Africa — engineered for trust, built for scale.",
    tags: ["Web Development", "UX Design", "Corporate Platform"],
    impact: ["Full product & services architecture", "Lead-generation contact flows", "Mobile-first industrial showcase"],
  },
  {
    slug: "souce-property",
    testId: "case-study-card-souce-property",
    client: "Souce Property",
    url: "https://souceproperty.com/",
    domain: "souceproperty.com",
    category: "Real Estate Investment",
    image: "/assets/cases/souce.png",
    imageFull: "/assets/cases/souce_full.png",
    title: "High-end property investment portal",
    summary:
      "A refined digital home for a Nottingham-based investment firm — guiding first-time and seasoned investors toward financial independence through strategic property.",
    tags: ["Web Development", "Brand Digitalisation", "Investor UX"],
    impact: ["Elegant editorial design system", "Service-led conversion journeys", "Content hub for investor education"],
  },
  {
    slug: "ai-warehouse",
    testId: "case-study-card-ai-warehouse",
    client: "AI Warehouse",
    url: "https://ai-warehouse.net/",
    domain: "ai-warehouse.net",
    category: "AI Marketing",
    image: "/assets/cases/aiwarehouse.png",
    imageFull: "/assets/cases/aiwarehouse_full.png",
    title: "The marketing platform for AI products and services",
    summary:
      "Our own flagship platform — a marketing engine built to promote AI products and services, connecting innovative AI tools with the business decision makers searching for them.",
    tags: ["Platform Engineering", "AI Marketing", "Directory Systems"],
    impact: ["Industry-indexed AI tools directory", "Intelligent search & compare engine", "Curated insights newsletter engine"],
  },
  {
    slug: "jenim-foods",
    testId: "case-study-card-jenim-foods",
    client: "Jenim Foods",
    url: "https://jenimfoods.com/",
    domain: "jenimfoods.com",
    category: "Food & FMCG",
    image: "/assets/cases/jenim.png",
    imageFull: "/assets/cases/jenim_full.png",
    title: "Appetite-first storefront for a khakhra snack brand",
    summary:
      "A clean, inviting digital shop for a snack maker — putting the health benefits and flavour range of their khakhras front and centre, from Garlic to Methi.",
    tags: ["Web Development", "E-commerce", "Brand Digitalisation"],
    impact: ["Product-led flavour catalogue", "Mobile-first shopping experience", "Quality & affordability storytelling"],
  },
  {
    slug: "company4me",
    testId: "case-study-card-company4me",
    client: "Company4Me",
    url: "https://company4me.com.au",
    domain: "company4me.com.au",
    category: "Business Services",
    image: "/assets/cases/company4me.png",
    imageFull: "/assets/cases/company4me_full.png",
    title: "Self-serve company registration platform",
    summary:
      "A user-friendly platform for registering companies, ABNs and business names across Australia — no hidden fees, no friction, just a straightforward process.",
    tags: ["Web Development", "Platform Engineering", "UX Design"],
    impact: ["Guided registration journeys", "Transparent pricing architecture", "Registry services showcase"],
  },
  {
    slug: "mantra-ad",
    testId: "case-study-card-mantra-ad",
    client: "Mantra Ad",
    url: "https://mantraad.com/",
    domain: "mantraad.com",
    category: "Advertising & Media",
    image: "/assets/cases/mantra.png",
    imageFull: "/assets/cases/mantra_full.png",
    title: "Digital home for a full-service advertising agency",
    summary:
      "A modern, confident showcase for an agency spanning hoardings, transit, cinema and social media — built to help brands stand out in a competitive market.",
    tags: ["Web Development", "Creative Direction", "UX Design"],
    impact: ["Service-range architecture", "Portfolio-led storytelling", "Enquiry-driven conversion flows"],
  },
  {
    slug: "the-beauty-in-things",
    testId: "case-study-card-beauty-in-things",
    client: "The Beauty in Things",
    url: "https://thebeautyinthings.com/",
    domain: "thebeautyinthings.com",
    category: "Photography & Fine Art",
    image: "/assets/cases/beautyinthings.png",
    imageFull: "/assets/cases/beautyinthings_full.png",
    title: "Gallery-grade store for limited edition prints",
    summary:
      "A quiet, elegant storefront for a professional photographer — letting limited edition fine art prints breathe and collectors buy with confidence.",
    tags: ["Web Development", "E-commerce", "Art Direction"],
    impact: ["Gallery-style print showcase", "Collector-friendly purchasing", "Gift card & edition flows"],
  },
];

export const SERVICES = [
  {
    id: "web-development",
    testId: "service-card-web-dev",
    index: "01",
    title: "Web Development",
    hook: "Websites engineered like products.",
    description:
      "Responsive, lightning-fast web platforms tailored to your exact objectives. From marketing sites that win awards to complex portals that run businesses — every line of code is bespoke, every pixel deliberate.",
    points: ["Custom React architectures", "Headless CMS & e-commerce", "Motion-rich, award-grade interfaces", "Performance & SEO engineered in"],
  },
  {
    id: "mobile-app-development",
    testId: "service-card-mobile-app",
    index: "02",
    title: "Mobile App Development",
    hook: "Apps your users refuse to delete.",
    description:
      "Cross-platform mobile experiences with native feel. We design and build apps that are fast, intuitive and obsessively polished — from first sketch to App Store launch and beyond.",
    points: ["iOS & Android from one codebase", "Offline-first architecture", "Push, payments & analytics built-in", "Launch + iteration partnership"],
  },
  {
    id: "digital-marketing",
    testId: "service-card-digital-marketing",
    index: "03",
    title: "Digital Marketing",
    hook: "Visibility, measured in revenue.",
    description:
      "Impactful digital marketing that drives growth and compounds online visibility — SEO, paid media and content, anchored by AI Warehouse, our own platform dedicated to promoting AI products and services.",
    points: ["Technical SEO & content strategy", "Paid acquisition that pays back", "Analytics & conversion optimisation", "Promotion via AI Warehouse, our AI marketing platform"],
    spotlight: true,
  },
];

export const TEAM = [
  {
    name: "Marcus Vance",
    role: "Founder & Creative Director",
    bio: "Sets the creative bar. Fifteen years turning ambitious briefs into digital products people remember.",
    image:
      "https://images.unsplash.com/photo-1764545973653-94c40d993495?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
  },
  {
    name: "Elena Rostova",
    role: "Lead Systems Architect",
    bio: "Designs the invisible — the APIs, pipelines and infrastructure that make the beautiful things fast.",
    image:
      "https://images.unsplash.com/photo-1782069327238-c154984f06ac?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
  },
  {
    name: "David Chen",
    role: "Head of AI & Mobile",
    bio: "Leads our mobile and AI practice — the mind behind the intelligence in AI Warehouse.",
    image:
      "https://images.unsplash.com/photo-1764546899196-b53061b1b609?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
  },
  {
    name: "Amara Osei",
    role: "Head of Growth Marketing",
    bio: "Turns launches into momentum. Data-obsessed, creatively restless, allergic to vanity metrics.",
    image:
      "https://images.unsplash.com/photo-1573497019940-1c28c88b4f3e?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
  },
];
